import { render, staticRenderFns } from "./DataReportOweDetailStatistics.vue?vue&type=template&id=6191d085&scoped=true"
import script from "./DataReportOweDetailStatistics.vue?vue&type=script&lang=js"
export * from "./DataReportOweDetailStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataReportOweDetailStatistics.vue?vue&type=style&index=0&id=6191d085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6191d085",
  null
  
)

export default component.exports